<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="80" label="序号"> </el-table-column>
      <el-table-column label="订场名称" prop="Name"></el-table-column>
      <el-table-column label="标识" prop="Sign"></el-table-column>
      <el-table-column label="设施" prop="Facilities"></el-table-column>
      <el-table-column label="标签" prop="Tag"></el-table-column>
      <el-table-column
        label="简介"
        prop="Desc"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="封面" width="180">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.Picture"
            fit="cover"
            :preview-src-list="[scope.row.Picture]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="最低价格" prop="MinPrice"></el-table-column>
      <el-table-column label="最高价格" prop="MaxPrice"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSite(scope.row)"
            >查看场地</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" class="delBtn" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.pageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>

    <!--合并后的新增/编辑弹窗-->
    <el-dialog
      :title="dialogStatus === 'add' ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="45%"
    >
      <el-form
        :model="formData"
        label-width="100px"
        :rules="formRules"
        ref="dataForm"
        class="form-container"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="场馆名称" prop="Name">
              <el-input v-model="formData.Name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识" prop="Sign">
              <el-input v-model="formData.Sign"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="设施" prop="Facilities">
              <el-select
                v-model="formData.Facilities"
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in facilitiesList"
                  :key="item.Id"
                  :value="item.ItemText"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标签" prop="Tag">
              <el-select v-model="formData.Tag" multiple style="width: 100%">
                <el-option
                  v-for="item in tagList"
                  :key="item.Id"
                  :value="item.ItemText"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="价格区间">
              <div class="price-range-container">
                <el-input-number
                  v-model="formData.MinPrice"
                  :min="0"
                  :step="0.01"
                  placeholder="最低价格"
                  controls-position="right"
                  class="price-input"
                ></el-input-number>
                <span class="price-separator">-</span>
                <el-input-number
                  v-model="formData.MaxPrice"
                  :min="0"
                  :step="0.01"
                  placeholder="最高价格"
                  controls-position="right"
                  class="price-input"
                ></el-input-number>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="简介" prop="Desc">
          <el-input
            v-model="formData.Desc"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="入场须知" prop="Instructions">
          <el-input
            v-model="formData.Instructions"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="开票须知" prop="InvoiceNotice">
          <el-input
            v-model="formData.InvoiceNotice"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="退款须知" prop="RefundNotice">
          <el-input
            v-model="formData.RefundNotice"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面" prop="Picture">
          <div class="upload-tip">建议尺寸：800x800px</div>
          <Upload
            v-if="dialogVisible"
            @upload="(url) => handleUpload('Picture', url)"
            @delete="() => handleDelete('Picture')"
            :fileUrl="formData.Picture"
          ></Upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import Upload from "@/components/Upload.vue";
import UploadArr from "@/components/uploadImgArr.vue";
import {
  getCourtList,
  addCourt,
  deleteCourt,
  editCourt,
  courtDetail,
} from "@/api/stadium/stadium";
import { uploadUrl } from "../../../util/state";
import { GetSysDictByCode } from "@/api/SysDictionary/SysDictionary";
import util from "../../../util/date";
export default {
  components: { Toolbar, Upload },
  data() {
    return {
      filters: {},
      buttonList: [],
      list: [],
      total: 0,
      listLoading: false,
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogStatus: "add",
      submitLoading: false,
      formData: {},
      formRules: {
        Name: [{ required: true, message: "请输入场馆名称", trigger: "blur" }],
        Sign: [{ required: true, message: "请输入标识", trigger: "blur" }],
        MinPrice: [
          { required: true, message: "请输入最低价格", trigger: "blur" },
        ],
        MaxPrice: [
          { required: true, message: "请输入最高价格", trigger: "blur" },
        ],
        Picture: [
          { required: true, message: "请上传封面图片", trigger: "change" },
        ],
      },
      fileAdress: uploadUrl,
      myHeaders: {},
      fullscreenLoading: false,
      tagList: [],
      facilitiesList: [],
    };
  },
  methods: {
    handleSite(row) {
      this.$router.push({
        path: "/stadium/site",
        query: { Id: this.$route.query.Id, cId: row.Id },
      });
    },
    handleEdit(row) {
      courtDetail({ Id: row.Id }).then((res) => {
        this.dialogStatus = "edit";
        this.formData = res.data.response;
        this.formData.Tag = this.formData.Tag.split(",");
        this.formData.Facilities = this.formData.Facilities.split(",");
        if (this.formData.Picture != null) {
          this.formData.PictureImg = [
            { name: "封面图", url: this.formData.Picture },
          ];
        }
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs["dataForm"].clearValidate();
        });
      });
    },
    handleDel(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteCourt({
          Id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }

          this.getList();
        });
      });
    },
    handleAdd() {
      this.dialogStatus = "add";
      this.formData = {
        Tag: [],
        Facilities: [],
        MinPrice: 0,
        MaxPrice: 0,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
    handleUpload(type, url) {
      this.formData[type] = url;
    },
    handleDelete(type) {
      this.formData[type] = this.dialogStatus === "edit" ? null : "";
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    getList() {
      if (!this.$route.query.Id) {
        this.$message.error("请先选择场馆");
        this.$router.back();
        return;
      }
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        key: this.filters.name,
        Id: this.$route.query.Id,
      };
      this.listLoading = true;

      getCourtList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) return;

        this.submitLoading = true;
        const data = {
          ...this.formData,
          Tag: this.formData.Tag.join(","),
          Facilities: this.formData.Facilities.join(","),
          VenueId: this.$route.query.Id,
        };

        const request =
          this.dialogStatus === "add" ? addCourt(data) : editCourt(data);

        request
          .then((res) => {
            this.submitLoading = false;
            if (res.data.success) {
              this.$message.success(res.data.msg);
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch(() => {
            this.submitLoading = false;
          });
      });
    },
    getDict() {
      GetSysDictByCode({
        code: "Veneu_CG,VeneuCourt_DCSS",
      }).then((res) => {
        console.log(res.data.response);
        this.tagList = res.data.response.filter((item) => {
          return item.DictCode == "Veneu_CG";
        });
        this.facilitiesList = res.data.response.filter((item) => {
          return item.DictCode == "VeneuCourt_DCSS";
        });
        console.log("tagList");
        console.log(this.tagList);
      });
    },
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    console.log("buttonList", this.buttonList);
    this.getList();
    this.getDict();
  },
};
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.delBtn {
  color: #f56c6c;
}

.el-table {
  margin: 15px 0;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-dialog {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.el-dialog__header {
  background: #f5f7fa;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  margin-right: 0;
  border-bottom: 1px solid #ebeef5;
}

.el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.el-dialog__headerbtn {
  top: 20px;
}

.el-dialog__body {
  padding: 30px 25px;
}

.el-form-item {
  margin-bottom: 22px;
}

.el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.el-input__inner,
.el-textarea__inner {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s;
}

.el-input__inner:hover,
.el-textarea__inner:hover {
  border-color: #c0c4cc;
}

.el-input__inner:focus,
.el-textarea__inner:focus {
  border-color: #409eff;
}

.upload-tip {
  color: #909399;
  font-size: 12px;
  margin-bottom: 8px;
}

.price-range-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.price-input {
  flex: 1;

  :deep(.el-input__inner) {
    text-align: left;
    padding-left: 12px;
  }

  :deep(.el-input-number__decrease),
  :deep(.el-input-number__increase) {
    border-radius: 0;
    background: #f5f7fa;
  }
}

.price-separator {
  color: #909399;
  font-size: 14px;
  margin: 0;
  flex-shrink: 0;
}

.el-dialog__footer {
  padding: 20px 25px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.dialog-footer .el-button {
  padding: 9px 20px;
  font-size: 14px;
  border-radius: 4px;
  margin-left: 12px;
}

.dialog-footer .el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
}

.dialog-footer .el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.el-select {
  width: 100%;
}

.el-input-number {
  width: 100%;
}

.toolbar {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 15px;
}

.upload-container {
  width: 100%;
}

.upload-container .el-upload {
  width: 100%;
  text-align: left;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

.form-container {
  .el-row {
    margin-bottom: 0;
  }

  .el-col {
    margin-bottom: 0;
  }

  .el-form-item {
    margin-bottom: 22px;
  }

  .el-form-item__label {
    padding-right: 12px;
  }

  .el-select {
    width: 100%;
  }

  .el-textarea__inner {
    min-height: 80px;
  }
}
</style>
